import React, { useState, useRef, useLayoutEffect } from 'react';
// import './ConsultationModal.css'; // Migrating to Tailwind

import { addresses } from '../data/locations';

const ConsultationModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1);
  const [consultationType, setConsultationType] = useState('');
  const [location, setLocation] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEntering, setIsEntering] = useState(true);
  const stepsRef = useRef(null);

  useLayoutEffect(() => {
    // Animate modal entrance
    const timer = setTimeout(() => setIsEntering(false), 300);

    // Adjust height based on the active step
    if (stepsRef.current) {
      const activeStep = stepsRef.current.querySelector('.active-step');
      if (activeStep) {
        stepsRef.current.style.height = `${activeStep.offsetHeight}px`;
      }
    }

    return () => clearTimeout(timer);
  }, [step, isOpen]); // Add isOpen to dependencies

  // Conditionally render the modal based on isOpen prop
  if (!isOpen) {
    return null;
  }

  

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const scriptURL = "https://script.google.com/macros/s/AKfycbxTj7Qj7gsqZbgsbrKeqFQdiQ5mBQZud5g1ZNLQNB_RNXguhWBW2T8lc9ZIeBTIQBsd/exec";
    const form = e.target;
    const formData = new FormData(form);

    fetch(scriptURL, { method: 'POST', body: formData })
      .then(response => {
        console.log('Success!', response);
        setStep(5); // Go to success step
      })
      .catch(error => {
        console.error('Error!', error.message);
        // Optionally show an error message to the user
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handlePreviousStep = () => {
    setStep(prevStep => Math.max(1, prevStep - 1));
  };

  return (
    <div className={`fixed inset-0 w-full h-full bg-black/60 backdrop-blur-md flex items-center justify-center z-[1000] transition-opacity duration-300 ${isEntering ? 'opacity-0' : 'opacity-100'}`} onClick={onClose}>
      <div className={`bg-background p-6 md:p-16 rounded-lg w-[95%] md:w-[90%] max-w-[650px] relative text-center shadow-[0_15px_40px_rgba(0,0,0,0.2)] transition-all duration-300 ${isEntering ? 'scale-95 opacity-0' : 'scale-100 opacity-100'}`} onClick={(e) => e.stopPropagation()}>
        {step > 1 && (
          <button className="absolute top-4 left-4 md:top-6 md:left-6 bg-none border-none text-xl md:text-2xl text-[#aaa] cursor-pointer transition-all duration-300 hover:text-primary" onClick={handlePreviousStep}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-5 h-5 md:w-6 md:h-6 fill-current"><path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"/></svg>
          </button>
        )}
        <button className="absolute top-4 right-4 md:top-6 md:right-6 bg-none border-none text-3xl md:text-[2.5rem] text-[#aaa] cursor-pointer transition-all duration-300 hover:text-primary hover:rotate-90" onClick={onClose}>×</button>
        <div className="relative transition-[height] duration-500 ease-in-out overflow-hidden" ref={stepsRef}>
          <div className={`absolute top-0 left-0 right-0 transition-opacity duration-500 ease-in-out ${step === 1 ? 'opacity-100 visible static active-step' : 'opacity-0 invisible'}`}>
            <h2 className="font-serif text-3xl md:text-[2.5rem] mb-4 text-text">Every great kilt begins with a conversation.</h2>
            <p className="mb-6 md:mb-12 text-[#666] text-base md:text-[1.1rem]">How shall we meet?</p>
            <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 md:gap-8">
              <div className="border border-border p-6 md:p-10 px-6 md:px-8 cursor-pointer transition-all duration-400 ease-[cubic-bezier(0.19,1,0.22,1)] rounded-md hover:border-primary hover:-translate-y-2 hover:scale-105 hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]" onClick={() => { setConsultationType('Store'); setStep(2); }}>
                <h3 className="font-serif font-bold text-xl md:text-[1.5rem] mb-2 md:mb-3 text-primary">The Store Experience</h3>
                <p className="mb-0 text-[#666] text-base md:text-[1.1rem]">Join us in person at one of our locations.</p>
              </div>
              <div className="border border-border p-6 md:p-10 px-6 md:px-8 cursor-pointer transition-all duration-400 ease-[cubic-bezier(0.19,1,0.22,1)] rounded-md hover:border-primary hover:-translate-y-2 hover:scale-105 hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]" onClick={() => { setConsultationType('Digital'); setStep(3); }}>
                <h3 className="font-serif font-bold text-xl md:text-[1.5rem] mb-2 md:mb-3 text-primary">The Digital Consultation</h3>
                <p className="mb-0 text-[#666] text-base md:text-[1.1rem]">A dedicated video call with our kiltmakers.</p>
              </div>
            </div>
          </div>
          <div className={`absolute top-0 left-0 right-0 transition-opacity duration-500 ease-in-out ${step === 2 ? 'opacity-100 visible static active-step' : 'opacity-0 invisible'}`}>
            <h2 className="font-serif text-3xl md:text-[2.5rem] mb-4 text-text">Our Stores</h2>
            <p className="mb-6 md:mb-12 text-[#666] text-base md:text-[1.1rem]">Please select your preferred location.</p>
            <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 md:gap-8">
              {addresses.map((addr) => (
                <div className="border border-border p-6 md:p-10 px-6 md:px-8 cursor-pointer transition-all duration-400 ease-[cubic-bezier(0.19,1,0.22,1)] rounded-md hover:border-primary hover:-translate-y-2 hover:scale-105 hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)]" key={addr.name} onClick={() => { setLocation(addr.name); setStep(3); }}>
                  <h3 className="font-serif font-bold text-xl md:text-[1.5rem] mb-2 md:mb-3 text-primary">{addr.name}</h3>
                  <p className="mb-0 text-[#666] text-base md:text-[1.1rem]">{addr.address}</p>
                </div>
              ))}
            </div>
          </div>
          <div className={`absolute top-0 left-0 right-0 transition-opacity duration-500 ease-in-out ${step === 3 ? 'opacity-100 visible static active-step' : 'opacity-0 invisible'}`}>
            <h2 className="font-serif text-3xl md:text-[2.5rem] mb-4 text-text">{consultationType === 'Digital' ? 'Schedule Your Consultation' : 'Schedule Your Visit'}</h2>
            <p className="mb-6 md:mb-12 text-[#666] text-base md:text-[1.1rem]">Select a date and time for your measurement.</p>
            <DatePicker selectedDate={selectedDate} onDateChange={setSelectedDate} />
            <TimePicker selectedTime={selectedTime} onTimeSelect={setSelectedTime} />
            <button className="font-sans bg-gradient-to-b from-primary to-primary-dark text-white border-none py-3 md:py-[1.2rem] px-8 md:px-[3.5rem] text-base md:text-[1.1rem] font-medium uppercase tracking-[1.5px] cursor-pointer transition-all duration-300 rounded transform translate-y-0 hover:from-primary-dark hover:to-primary hover:shadow-[0_8px_25px_rgba(0,0,0,0.3)] hover:-translate-y-1 disabled:bg-[#999] disabled:cursor-not-allowed disabled:shadow-none disabled:transform-none w-full md:w-auto" disabled={!selectedTime} onClick={() => setStep(4)}>Confirm Date & Time</button>
          </div>
          <div className={`absolute top-0 left-0 right-0 transition-opacity duration-500 ease-in-out ${step === 4 ? 'opacity-100 visible static active-step' : 'opacity-0 invisible'}`}>
            <h2 className="font-serif text-3xl md:text-[2.5rem] mb-4 text-text">Your Details</h2>
            <p className="mb-6 md:mb-12 text-[#666] text-base md:text-[1.1rem]">We will contact you to confirm your appointment.</p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-5 text-left">
              <input type="hidden" name="consultationType" value={consultationType} />
              <input type="hidden" name="location" value={consultationType === 'Store' ? location : 'N/A'} />
              <input type="hidden" name="date" value={selectedDate.toDateString()} />
              <input type="hidden" name="time" value={selectedTime} />
              
              <input type="text" name="name" placeholder="Full Name" required className="font-sans text-base p-3 md:p-4 border border-border bg-white rounded transition-all duration-300 focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgba(185,151,110,0.2)]" />
              <input type="email" name="email" placeholder="Email Address" required className="font-sans text-base p-3 md:p-4 border border-border bg-white rounded transition-all duration-300 focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgba(185,151,110,0.2)]" />
              <input type="tel" name="phone" placeholder="Contact Number (+44 ext)" required className="font-sans text-base p-3 md:p-4 border border-border bg-white rounded transition-all duration-300 focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgba(185,151,110,0.2)]" />
              <textarea name="notes" placeholder="Any initial thoughts? (Optional)" className="font-sans text-base p-3 md:p-4 border border-border bg-white rounded transition-all duration-300 focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgba(185,151,110,0.2)] min-h-[100px] md:min-h-[120px] resize-y"></textarea>
              <button type="submit" className="font-sans bg-gradient-to-b from-primary to-primary-dark text-white border-none py-3 md:py-[1.2rem] px-8 md:px-[3.5rem] text-base md:text-[1.1rem] font-medium uppercase tracking-[1.5px] cursor-pointer transition-all duration-300 rounded transform translate-y-0 hover:from-primary-dark hover:to-primary hover:shadow-[0_8px_25px_rgba(0,0,0,0.3)] hover:-translate-y-1 disabled:bg-[#999] disabled:cursor-not-allowed disabled:shadow-none disabled:transform-none w-full md:w-auto" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Request Consultation'}
              </button>
            </form>
          </div>
          <div className={`absolute top-0 left-0 right-0 transition-opacity duration-500 ease-in-out ${step === 5 ? 'opacity-100 visible static active-step' : 'opacity-0 invisible'}`}>
            <div className="animate-fade-in">
              <h2 className="font-serif text-3xl md:text-[2.5rem] mb-4 text-text">Thank You</h2>
              <p className="mb-6 md:mb-12 text-[#666] text-base md:text-[1.1rem]">
                We have received your request. A member of the Mackintosh family
                will be in touch personally to begin our collaboration.
                {consultationType === 'Digital' && " Once confirmed, you will be sent a Zoom link for our meeting."}
              </p>
              <button className="font-sans bg-gradient-to-b from-primary to-primary-dark text-white border-none py-3 md:py-[1.2rem] px-8 md:px-[3.5rem] text-base md:text-[1.1rem] font-medium uppercase tracking-[1.5px] cursor-pointer transition-all duration-300 rounded transform translate-y-0 hover:from-primary-dark hover:to-primary hover:shadow-[0_8px_25px_rgba(0,0,0,0.3)] hover:-translate-y-1 mt-6 w-full md:w-auto" onClick={onClose}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper components remain the same
const DatePicker = ({ selectedDate, onDateChange }) => {
  const [currentMonth, setCurrentMonth] = useState(selectedDate.getMonth());
  const [currentYear, ] = useState(selectedDate.getFullYear());

  const renderDays = () => {
    const today = new Date();
    const days = [];
    const numDays = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDay = new Date(currentYear, currentMonth, 1).getDay();

    for (let i = 0; i < firstDay; i++) days.push(<div key={`empty-${i}`} className="text-center py-2 md:py-3"></div>);

    for (let day = 1; day <= numDays; day++) {
      const date = new Date(currentYear, currentMonth, day);
      const isSelected = date.toDateString() === selectedDate.toDateString();
      const isPast = date < today && !isSelected;
      days.push(
        <div 
          key={day} 
          className={`text-center py-2 md:py-3 text-sm md:text-base rounded transition-colors duration-300 ${isSelected ? 'bg-primary text-white font-bold border border-primary-dark' : ''} ${isPast ? 'text-[#ccc] cursor-not-allowed' : 'cursor-pointer hover:bg-primary'}`}
          onClick={() => !isPast && onDateChange(date)}
        >
          {day}
        </div>
      );
    }
    return days;
  };

  return (
    <div className="mb-4 md:mb-8">
      <div className="flex justify-between items-center mb-4">
        <button className="bg-none border-none text-xl md:text-2xl cursor-pointer text-primary" onClick={() => setCurrentMonth(currentMonth - 1)}>‹</button>
        <span className="text-sm md:text-base font-medium">{new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' })}</span>
        <button className="bg-none border-none text-xl md:text-2xl cursor-pointer text-primary" onClick={() => setCurrentMonth(currentMonth + 1)}>›</button>
      </div>
      <div className="grid grid-cols-7 gap-1 md:gap-2">
        <div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">S</div><div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">M</div><div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">T</div><div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">W</div><div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">T</div><div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">F</div><div className="text-center py-2 md:py-3 text-xs md:text-base font-medium text-[#888]">S</div>
        {renderDays()}
      </div>
    </div>
  );
};

const TimePicker = ({ selectedTime, onTimeSelect }) => {
  const timeSlots = ["08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00"];
  return (
    <div className="mb-8">
      <div className="time-picker-wrapper">
        <select
          value={selectedTime}
          onChange={(e) => onTimeSelect(e.target.value)}
          className="w-full font-sans text-base p-4 border border-border bg-white rounded transition-all duration-300 focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgba(185,151,110,0.2)]"
        >
          <option value="">Select a time</option>
          {timeSlots.map(time => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ConsultationModal;